module.exports = __webpack_public_path__ + "static/img/15-海康威视.8e8557e6.jpg";